export interface Dimensions {
    width: number;
    height: number;
}

export default interface Photo {
    readonly id: string;
    readonly filename: string;
    readonly largeThumbUrl: string;
    readonly smallThumbUrl: string;
    readonly dimensions: Dimensions;
    readonly smallThumbDimensions: Dimensions;
    readonly largeThumbDimensions: Dimensions;
    readonly recommended: boolean;
    readonly finalized: boolean;
    readonly surcharge?: number|null;
    readonly saleMode?: 'all'|'noDigital'|'digitalOnly';
    readonly dataHash?: string;
    readonly perceptualHash?: string;
    readonly orderedBy: string[];
    readonly likedBy: string[];
}

export const isPhoto = (p: unknown): p is Photo => !!((p as Photo).id);
